import { formatter, formatterBalance } from "../../utils/formatCurrency";
import plaidBankIcon from "../../assets/plaidBankIcon.svg";
import { Button } from "../button/index.jsx";
import React from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from 'react-i18next';

export const DebitBodyContent = ({ setViewTC = null, obvInfo = {}, handleConfirm = null }) => {
  const {amount, accountSubType, startingBalance, accountCurrency} = obvInfo;
  const { t } = useTranslation();

  const txTypeName = t('debit.confirm.title');
  const txConfirm = t('obv.button.confirm');
  const txAmount = `${formatter(amount)}`;
  const balance = startingBalance ?
      `${formatterBalance(startingBalance, accountCurrency)}` : null;

  return (
      <>
        <div className='bankBranding'>
          <img src={plaidBankIcon} alt='bankIcon'/>
          <h1>{obvInfo.institutionName}</h1>
        </div>
        <h1 className='header'>{txTypeName}</h1>
        <p className='key mt-n15'>{t('debit.labels.from')}</p>
        <div className='infoBox'>
          <p className='value'>
            <b>{accountSubType.charAt(0).toUpperCase()
            + accountSubType.slice(1)} account</b>
          </p>
          <p className='value'><b>{balance}</b></p>
        </div>
        <div className="infoBox">
          <h6 className='subText'>****{obvInfo.accountMask}</h6>
        </div>
        <hr className='divider'/>
        <div className='infoBox'>
          <p className='key'>{t('debit.labels.amount')}</p>
          <p className='value'><b>{txAmount}</b></p>
        </div>
        <hr className='divider'/>
        <div className='infoBox'>
          <p className='key'>{t('debit.labels.to')}</p>
          <p className='value'><b>{obvInfo.merchantName}</b></p>
        </div>
        <div className='mt-15'>
          <Button className='mt-15' type='default'
                  onClick={() => handleConfirm(obvInfo.clientReferenceId)}>
            {txConfirm} {txAmount} {txTypeName}
          </Button>
          <div className='tcContainer' role="button"
               tabIndex={0} onClick={() => setViewTC(true)} onKeyDown={() => setViewTC(true)}>
            <h6 className='text-center'>
              <Trans
                i18nKey="common.terms.agreement"
                components={{
                  bold: <b />
                }}
              />
            </h6>
          </div>
        </div>
      </>
  );
}

DebitBodyContent.propTypes = {
  setViewTC: PropTypes.func,
  obvInfo: PropTypes.object,
  handleConfirm: PropTypes.func,
};